import { render, staticRenderFns } from "./EditBidExplanationsModal.vue?vue&type=template&id=2843ad30&scoped=true&"
import script from "./EditBidExplanationsModal.vue?vue&type=script&lang=js&"
export * from "./EditBidExplanationsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditBidExplanationsModal.vue?vue&type=style&index=0&id=2843ad30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843ad30",
  null
  
)

export default component.exports